



























import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosStation, MelosContentOrder, MelosContentType } from '@/services/api.service';
import MelosButton from '@/components/MelosButton.vue';

@Component({
  components: {
    MelosButton,
  },
})
export default class StationSchedule extends Vue {

  private get stationData(): MelosStation {
    return this.$store.state.ownedStations.find((station: MelosStation) => {
      return station._id === this.$route.params.stationId;
    });
  }

  private get stationName(): string {
    return this.stationData?.name || '';
  }

  private goToSlot(index: number) {
    this.$router.push({ path: `/stations/${this.stationData._id}/schedule/slot/${index}` });
  }

  private addNewSlot() {
    let newSlotData;
    if ((this.stationData?.period_config || []).length === 0) {
      newSlotData = {
        start:  '000000',
        end: '235959',
        content: [{
          name: 'Pop',
          type: MelosContentType.TAG_BASED,
          provider: 'jamendo',
          tag: 'pop',
          weight: 1,
        }],
        content_order: MelosContentOrder.WEIGHT_BASED,
      };
      this.stationData.period_config = [newSlotData];
      return;
    }
    const lastSlot = this.stationData.period_config[this.stationData.period_config.length - 1];
    const lastSlotDuration = this.getSlotDuration(lastSlot);
    lastSlot.end = this.getSlotEndTime(lastSlot.start, lastSlotDuration / 2);
    newSlotData = {
      start: lastSlot.end,
      end: '235959',
      content: [{
        name: 'Pop',
        type: MelosContentType.TAG_BASED,
        provider: 'jamendo',
        tag: 'pop',
        weight: 1,
      }],
      content_order: MelosContentOrder.WEIGHT_BASED,
    };
    this.stationData.period_config[this.stationData.period_config.length - 1] = lastSlot;
    this.stationData.period_config.push(newSlotData);
  }

  private getSlotEndTime(start: string, duration: number): string {
    const hour = Number(start.slice(0, 2));
    const minute = Number(start.slice(2, 4));
    const second = Number(start.slice(4, 6));
    return `${hour + Math.trunc(duration / 3600)}${minute + Math.trunc(duration / 60)}${second + (duration % 3600)}`;
  }

  private getSlotDuration(slotData: any): number {
    const startHour = Number(slotData.start.slice(0, 2));
    const startMinute = Number(slotData.start.slice(2, 4));
    const startSecond = Number(slotData.start.slice(4, 6));
    const endHour = Number(slotData.end.slice(0, 2));
    const endMinute = Number(slotData.end.slice(2, 4));
    const endSecond = Number(slotData.end.slice(4, 6));
    const startDaySecond = startHour * 3600 + startMinute * 60 + startSecond;
    const endDaySecond = endHour * 3600 + endMinute * 60 + endSecond;
    return endDaySecond - startDaySecond;
  }

  private getSlotHeight(slotData: any): number {
    return this.getSlotDuration(slotData) / 3600;
  }

  private getSlotTime(timeData: string): string {
    const hour = timeData.slice(0, 2);
    const minute = timeData.slice(2, 4);
    return `${hour}:${minute}`;
  }

}
